import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const RemoveIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM5 7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5Z", fill: "currentColor" })));
});
RemoveIcon.displayName = 'RemoveIcon';
export default RemoveIcon;
